import request from 'utils/request'

// 获取指标预警管理列表
export const getList = data =>
  request().post('finance/warning/config/list', data)

// 保存数据
export const saveData = data => request().post('finance/warning/config', data)
